export default {"src":"/_next/static/media/videoType.29a2222f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};